<div class="error-box">
  <div class="error-body text-center">
      <h1 class="error-title text-danger">{{statusCode}}</h1>
      <h3 class="text-uppercase error-subtitle">{{statusText}}</h3>
      <div class="alert alert-danger">{{message}}</div>
  </div>
</div>
